export const forceTextInCSV = (text?: string): string => {
  if (!text) {
    return '';
  }

  return `="${text.trim()}"`;
};
